import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_MATERIAL_DATA: createAsyncActionConstants('FETCH_MATERIAL_DATA'),
    FETCH_CUSTOMER_DATA: createAsyncActionConstants('FETCH_CUSTOMER_DATA'),
    RESET_CUSTOMER_DATA: createAsyncActionConstants('RESET_CUSTOMER_DATA')
}